import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryOrderExpresss(
  {
    page, size, direction, sort, orderId,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/order-expresss`,
    method: 'get',
    params: {
      page,
      orderId,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryOrderExpress(orderExpressId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/order-expresss/${orderExpressId}`,
    method: 'get',
  });
}

/**
 * 根据 id 查询 订单详细信息；
 * @param  orderExpressId
 * @returns
 */
export function _queryOrderExpressTrack(orderExpressId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/order-express/${orderExpressId}/detail`,
    method: 'get',
  });
}
/**
 * 新增
 * @param  orderId
 * @param  expressNo
 * @param  status
 * @param  sender
 * @param  mobile
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addOrderExpress(
  {
    orderId,
    expressNo,
    expressCompanyCode,
    status,
    sender,
    mobile,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/order-expresss`,
    method: 'post',
    data: {
      orderId,
      expressNo,
      expressCompanyCode,
      status,
      sender,
      mobile,
    },
  });
}

/**
 * 更新
 * @param orderExpressId
 * @param  orderId
 * @param  expressNo
 * @param  status
 * @param  sender
 * @param  mobile
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateOrderExpress(orderExpressId, {
  orderId,
  expressNo,
  expressCompanyCode,
  status,
  sender,
  mobile,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/order-expresss/${orderExpressId}`,
    method: 'patch',
    data: {
      orderId,
      expressNo,
      expressCompanyCode,
      status,
      sender,
      mobile,
    },
  });
}

/**
 * 删除
 * @param orderExpressId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteOrderExpress(orderExpressId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/order-expresss/${orderExpressId}`,
    method: 'delete',
  });
}

export default {};
